<template>
  <label class="cp-schema-li-wrapper">
    <span class="cp-schema-li-label">{{ itemLabel }}</span>
    <template v-if="item.type === 'text'">
      <input type="text"
             class="cp-schema-li-input"
             v-model="item.value"
             :required="isRequired"
             :maxlength="ruleMaxLength"
             :minlength="ruleMinLength"
             :placeholder="optionPreTypedText"
      />
    </template>
    <template v-if="item.type === 'checkbox'">
      <input type="checkbox"
             class="cp-schema-li-input"
             v-model="item.value"
             :required="isRequired"
      />
    </template>
    <template v-if="showValidation">
      <div
        v-for="(rule, key) in item.rules"
        v-if="ruleIsActive(rule) && !rule.valid"
        :key="key"
        class="cp-schema-li-validation-message"
      >{{ getValidationMessage(rule) }}</div>
    </template>
  </label>
</template>

<script>
import localizationMuiMixin from '../mixins/localizationMuiMixin'

export default {
  mixins: [localizationMuiMixin],
  name: 'AdvCartProductCustomizationEditorItem',
  props: {
    item: Object
  },
  computed: {
    itemLabel () {
      return this.getLocalizedMuiValue(this.item.name)
    },
    isRequired () {
      if (!this.ruleIsActive('required')) {
        return false
      }

      return this.getRuleProperty('required', 'value', false)
    },
    ruleMaxLength () {
      if (!this.ruleIsActive('maxLength')) {
        return false
      }

      return this.getRuleProperty('maxLength', 'value', '')
    },
    ruleMinLength () {
      if (!this.ruleIsActive('minLength')) {
        return false
      }

      return this.getRuleProperty('minLength', 'value', '')
    },
    optionPreTypedText () {
      const optionValue = this.getOptionProperty('preTypedText', 'value', false)
      if (!optionValue) {
        return ''
      }
      return this.getLocalizedMuiValue(optionValue)
    },
    showValidation () {
      return this.item.value !== '' || this.isRequired
    }
  },
  methods: {
    getValidationMessage (rule) {
      const inputType = this.getRuleProperty(rule, 'inputType')
      const property = this.getRuleProperty(inputType, 'propertyName')
      return this.$t(
        `form_validation_${property}`,
        { params: [this.getRuleProperty(rule, 'value')] }
      )
    },
    ruleIsActive (rule) {
      return this.getRuleProperty(rule, 'active')
    },
    getRuleProperty (rule, propertyKey, defaultValue = null) {
      if (!(rule in this.item.rules)) {
        return defaultValue
      }
      if (!(propertyKey in this.item.rules[rule])) {
        return defaultValue
      }
      return this.item.rules[rule][propertyKey]
    },
    getOptionProperty (option, propertyKey, defaultValue = null) {
      if (!(option in this.item.options)) {
        return defaultValue
      }
      if (!(propertyKey in this.item.options[option])) {
        return defaultValue
      }
      return this.item.options[option][propertyKey]
    }
  }
}
</script>

<style lang="scss" scoped>
@import "AdvCartProductCustomizationEditorStyling.scss";
</style>
